/* Doro - FAQ (inRiver) - behaviour of sections/faq-inriver.liquid */
(function () {
function init(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var D = {};
  try { D = JSON.parse(root.querySelector('.df-data').textContent); } catch (e) { return; }
  var T = D.t || {};
  var store = root.querySelector('.df-list');
  var results = root.querySelector('.df-results');
  var form = root.querySelector('.df-form');
  var input = form.querySelector('input');
  var status = root.querySelector('.df-status');
  var empty = root.querySelector('.df-empty');
  var loading = root.querySelector('.df-loading');
  var title = root.querySelector('.df-title');
  var here = root.querySelector('.df-crumb-here');
  var tpl = root.querySelector('.df-fb-tpl');
  var baseTitle = document.title;
  var cats = D.cats || [], bySlug = {}, byKey = {};
  cats.forEach(function (c) { bySlug[c.slug] = c; byKey[c.key] = c; });
  var items = [], loaded = false, state = { topic: null, q: '', all: false }, timer;

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[_\-./®]+/g, ' '); }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function store_get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function store_set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function prep(el) {
    var q = el.querySelector('.df-q');
    el._qt = q.textContent;
    el._q = norm(el._qt);
    el._s = el._q + ' ' + norm(el.querySelector('.df-a').textContent);
    el._cats = el.getAttribute('data-cats').trim().split(/\s+/);
    el._primary = null;
    for (var i = 0; i < el._cats.length; i++) { if (byKey[el._cats[i]]) { el._primary = el._cats[i]; break; } }
    items.push(el);
  }
  store.querySelectorAll('.df-item').forEach(prep);

  // ---------- feedback + copy link (added when a question is first opened) ----------
  function addFeedback(el) {
    if (el._fb || !tpl) return;
    var fb = tpl.content.firstElementChild.cloneNode(true);
    el.appendChild(fb); el._fb = fb;
    var id = el.getAttribute('data-id');
    var ask = fb.querySelector('.df-fb-ask'), thanks = fb.querySelector('.df-fb-thanks');
    if (store_get('df-vote-' + id)) { ask.hidden = true; thanks.hidden = false; }
    fb.querySelectorAll('.df-vote').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-v');
        ask.hidden = true; thanks.hidden = false;
        if (store_get('df-vote-' + id)) return;
        store_set('df-vote-' + id, v);
        if (D.endpoint) {
          var body = JSON.stringify({ id: id, vote: v, lang: D.locale || document.documentElement.lang || '', country: D.country || '', path: location.pathname });
          try { fetch(D.endpoint, { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {}); } catch (e) {}
        }
      });
    });
    var copy = fb.querySelector('.df-copy'), copied = fb.querySelector('.df-copied');
    copy.addEventListener('click', function () {
      var link = location.origin + location.pathname + '#faq-' + id;
      function done() { copied.textContent = T.copied || 'Link copied'; setTimeout(function () { copied.textContent = ''; }, 2500); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, fallback); else fallback();
      function fallback() {
        var ta = document.createElement('textarea'); ta.value = link; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (e) { window.prompt('', link); }
        document.body.removeChild(ta);
      }
    });
  }
  root.addEventListener('toggle', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('df-item')) return;
    if (el.open) {
      addFeedback(el);
      var u = new URL(location.href); u.hash = el.id; history.replaceState(history.state, '', u);
    } else if (location.hash === '#' + el.id) {
      var v = new URL(location.href); v.hash = ''; history.replaceState(history.state, '', v);
    }
  }, true);

  // ---------- counts ----------
  function counts() {
    if (!loaded) return;
    cats.forEach(function (c) { c.n = 0; });
    items.forEach(function (el) { el._cats.forEach(function (k) { if (byKey[k]) byKey[k].n++; }); });
    root.querySelectorAll('[data-count-for]').forEach(function (s) {
      var c = byKey[s.getAttribute('data-count-for')];
      if (c) s.textContent = (T.count || '[count]').replace('[count]', c.n);
    });
    root.querySelectorAll('.df-card, .df-chip').forEach(function (a) {
      var c = bySlug[a.getAttribute('data-topic')];
      a.hidden = !c || c.n === 0;
    });
  }

  // ---------- views ----------
  function setQ(el, words) {
    var q = el.querySelector('.df-q');
    if (!words.length) { if (el._hl) { q.textContent = el._qt; el._hl = false; } return; }
    var re = new RegExp('(' + words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    q.innerHTML = el._qt.split(re).map(function (t, i) { return i % 2 ? '<mark>' + esc(t) + '</mark>' : esc(t); }).join('');
    el._hl = true;
  }
  function setTag(el, text) {
    var w = el.querySelector('.df-qwrap'), t = w.querySelector('.df-tag');
    if (!text) { if (t) t.remove(); return; }
    if (!t) { t = document.createElement('span'); t.className = 'df-tag'; w.insertBefore(t, w.firstChild); }
    t.textContent = text;
  }
  function render() {
    items.forEach(function (el) { el.hidden = false; setTag(el, ''); store.appendChild(el); });
    results.innerHTML = '';
    var view = state.q ? 'search' : (state.topic && bySlug[state.topic]) ? 'topic' : 'home';
    root.setAttribute('data-view', view);
    status.textContent = ''; empty.hidden = true;
    loading.hidden = loaded || view === 'home';
    var c = view === 'topic' ? bySlug[state.topic] : null;
    title.textContent = c ? c.name : T.heading;
    here.textContent = c ? c.name : '';
    document.title = c ? c.name + ' – ' + baseTitle : baseTitle;
    var words = view === 'search' ? norm(state.q).trim().split(/\s+/).filter(Boolean) : [];
    items.forEach(function (el) { setQ(el, words); });

    if (view === 'topic') {
      var list = items.filter(function (el) { return el._cats.indexOf(c.key) > -1; });
      var limit = state.all ? list.length : 10;
      var box = document.createElement('div'); box.className = 'df-group';
      list.forEach(function (el, i) { el.hidden = i >= limit; box.appendChild(el); });
      results.appendChild(box);
      if (list.length > limit) {
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'df-more';
        more.textContent = (T.show_all || '').replace('[count]', list.length);
        more.addEventListener('click', function () {
          state.all = true; render();
          var next = list[limit] && list[limit].querySelector('summary'); if (next) next.focus();
        });
        box.appendChild(more);
      }
      root.querySelectorAll('.df-chip').forEach(function (a) { a.hidden = a.getAttribute('data-topic') === state.topic || (loaded && bySlug[a.getAttribute('data-topic')] && bySlug[a.getAttribute('data-topic')].n === 0); });
    } else if (view === 'search') {
      var groups = {}, order = [], total = 0;
      items.forEach(function (el, idx) {
        if (!words.every(function (w) { return el._s.indexOf(w) > -1; })) return;
        var inQ = words.every(function (w) { return el._q.indexOf(w) > -1; });
        el._score = inQ ? 2 : 1; el._idx = idx; total++;
        setTag(el, inQ ? '' : T.in_answer);
        var k = el._primary || '_';
        if (!groups[k]) { groups[k] = { key: k, items: [], best: 0 }; order.push(groups[k]); }
        groups[k].items.push(el); if (el._score > groups[k].best) groups[k].best = el._score;
      });
      order.sort(function (a, b) { return (b.best - a.best) || (b.items.length - a.items.length); });
      order.forEach(function (g) {
        g.items.sort(function (a, b) { return (b._score - a._score) || (a._idx - b._idx); });
        var cat = byKey[g.key], wrap = document.createElement('div');
        wrap.className = 'df-group';
        if (cat) {
          var head = document.createElement('div'); head.className = 'df-group-head';
          var h = document.createElement('h2'); h.textContent = cat.name; head.appendChild(h);
          var a = document.createElement('a'); a.href = '?topic=' + cat.slug; a.setAttribute('data-topic', cat.slug);
          a.textContent = (T.all_in_topic || '').replace('[count]', cat.n > 0 ? cat.n : '').replace(/\s+/g, ' ').trim();
          head.appendChild(a); wrap.appendChild(head);
        }
        g.items.forEach(function (el) { wrap.appendChild(el); });
        results.appendChild(wrap);
      });
      if (total) status.textContent = (total > 1 ? T.found_many : T.found_one || '').replace('[count]', total).replace('[query]', state.q);
      else if (loaded) { empty.hidden = false; empty.querySelector('strong').textContent = (T.empty_title || '').replace('[query]', state.q); }
    }
  }

  // ---------- URL state ----------
  function fromUrl() {
    var p = new URLSearchParams(location.search);
    state.q = (p.get('q') || '').trim().slice(0, 80);
    state.topic = p.get('topic');
    state.all = false;
    if (input.value.trim() !== state.q) input.value = state.q;
  }
  function toUrl(push) {
    var u = new URL(location.href);
    u.searchParams.delete('topic'); u.searchParams.delete('q'); u.hash = '';
    if (state.q) u.searchParams.set('q', state.q); else if (state.topic) u.searchParams.set('topic', state.topic);
    history[push ? 'pushState' : 'replaceState']({ df: 1 }, '', u);
  }
  function goTopic(slug) {
    state.topic = slug; state.q = ''; state.all = false; input.value = '';
    toUrl(true); render();
    root.scrollIntoView({ block: 'start' });
    title.focus({ preventScroll: true });
  }
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-topic], a.df-home-link');
    if (!a || !root.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    goTopic(a.classList.contains('df-home-link') ? null : a.getAttribute('data-topic'));
  });
  root.querySelector('.df-clear').addEventListener('click', function () {
    state.q = ''; input.value = ''; toUrl(false); render(); input.focus();
  });
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var q = input.value.trim().slice(0, 80);
      if (q === state.q) return;
      var wasSearch = !!state.q; state.q = q; state.all = false;
      toUrl(!wasSearch && !!q); render();
    }, 150);
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); state.q = input.value.trim().slice(0, 80); toUrl(false); render(); input.blur(); });
  window.addEventListener('popstate', function () { fromUrl(); render(); });

  function openFromHash() {
    if (location.hash.indexOf('#faq-') !== 0) return false;
    var el = root.querySelector(location.hash.replace(/[^#\w-]/g, ''));
    if (!el || !el.classList.contains('df-item')) return false;
    if (!state.q && (!state.topic || el._cats.indexOf((bySlug[state.topic] || {}).key) < 0)) {
      var c = byKey[el._primary];
      if (c) { state.topic = c.slug; var u = new URL(location.href); u.searchParams.set('topic', c.slug); history.replaceState({ df: 1 }, '', u); }
    }
    state.all = true; render();
    el.hidden = false; el.open = true; addFeedback(el);
    el.scrollIntoView({ block: 'start' });
    var s = el.querySelector('summary'); if (s) s.focus({ preventScroll: true });
    return true;
  }

  // ---------- load the remaining pages (beyond the first 250) ----------
  var sid = root.getAttribute('data-section');
  function nextUrl(pg) {
    var n = pg && pg.getAttribute('data-next');
    if (!n) return null;
    var u = new URL(n, location.origin);
    new URLSearchParams(location.search).forEach(function (v, k) { if (!u.searchParams.has(k) && k !== 'q' && k !== 'topic') u.searchParams.set(k, v); });
    u.searchParams.set('section_id', sid);
    return u.toString();
  }
  function loadNext(url, guard) {
    if (!url || guard > 10) return Promise.resolve();
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('FAQ page ' + r.status); return r.text(); })
      .then(function (html) {
        var pg = new DOMParser().parseFromString(html, 'text/html').querySelector('.df-page');
        if (!pg) return;
        var next = nextUrl(pg);
        pg.querySelectorAll('.df-item').forEach(function (el) { el = document.importNode(el, true); store.appendChild(el); prep(el); });
        return loadNext(next, guard + 1);
      })
      .catch(function (e) { console.warn('[FAQ]', e); });
  }

  fromUrl();
  render();
  var hashDone = openFromHash();
  loadNext(nextUrl(root.querySelector('.df-page')), 0).then(function () {
    loaded = true;
    counts();
    render();
    if (!hashDone) openFromHash();
  });
}
document.querySelectorAll('.df[data-section]').forEach(init);
})();